namespace Gamification.Gamification {
    export interface ProdottiSmtpForm {
        IdProdotto: Serenity.IntegerEditor;
        IsSMTPValido: Serenity.BooleanEditor;
        SMTPHost: Serenity.StringEditor;
        SMTPPort: Serenity.IntegerEditor;
        SMTPDisplayName: Serenity.StringEditor;
        SMTPFrom: Serenity.EmailAddressEditor;
        SMTPUsername: Serenity.StringEditor;
        SMTPPassword: Serenity.PasswordEditor;
        SMTPUseSsl: Serenity.BooleanEditor;
        SMTPUseStartTls: Serenity.BooleanEditor;
        SMTPSecureSocket: SmtpSecureSocketOptionsEditor;
        OggettoRegistrazione: Serenity.StringEditor;
        CorpoRegistrazione: Serenity.HtmlContentEditor;
        LinkRegistrazione: Serenity.StringEditor;
        OggettoResetPassword: Serenity.StringEditor;
        CorpoResetPassword: Serenity.HtmlContentEditor;
        LinkResetPassword: Serenity.StringEditor;
        OggettoCambiaPassword: Serenity.StringEditor;
        CorpoCambiaPassword: Serenity.HtmlContentEditor;
        OggettoCancellazione: Serenity.StringEditor;
        CorpoCancellazione: Serenity.HtmlContentEditor;
    }

    export class ProdottiSmtpForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ProdottiSmtp';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProdottiSmtpForm.init)  {
                ProdottiSmtpForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.StringEditor;
                var w3 = s.EmailAddressEditor;
                var w4 = s.PasswordEditor;
                var w5 = SmtpSecureSocketOptionsEditor;
                var w6 = s.HtmlContentEditor;

                Q.initFormType(ProdottiSmtpForm, [
                    'IdProdotto', w0,
                    'IsSMTPValido', w1,
                    'SMTPHost', w2,
                    'SMTPPort', w0,
                    'SMTPDisplayName', w2,
                    'SMTPFrom', w3,
                    'SMTPUsername', w2,
                    'SMTPPassword', w4,
                    'SMTPUseSsl', w1,
                    'SMTPUseStartTls', w1,
                    'SMTPSecureSocket', w5,
                    'OggettoRegistrazione', w2,
                    'CorpoRegistrazione', w6,
                    'LinkRegistrazione', w2,
                    'OggettoResetPassword', w2,
                    'CorpoResetPassword', w6,
                    'LinkResetPassword', w2,
                    'OggettoCambiaPassword', w2,
                    'CorpoCambiaPassword', w6,
                    'OggettoCancellazione', w2,
                    'CorpoCancellazione', w6
                ]);
            }
        }
    }
}
